import axios from 'axios';

const mid = sessionStorage.getItem('mid') || null;
const token = sessionStorage.getItem('token') || null;
const csrfTokenFromMeta = document.querySelector('meta[name="csrf-token"]').content;

export const loginPost = (email, password, csrfToken) => {
    let loginRequest = axios.create();
    loginRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    loginRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken || csrfTokenFromMeta;
    return loginRequest.post('/api/member/login', {'email': email, 'password': password});
};

export const logoutPost = () => {
    let logoutRequest = axios.create();
    logoutRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    logoutRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    logoutRequest.defaults.headers.common['X-SEHSEH-Mid'] = mid;
    logoutRequest.defaults.headers.common['X-SEHSEH-Token'] = token;
    return logoutRequest.post('/api/member/logout', {});
};

export const forgetPost = (email) => {
    let forgetRequest = axios.create();
    forgetRequest.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    forgetRequest.defaults.headers.common['X-CSRF-TOKEN'] = csrfTokenFromMeta;
    return forgetRequest.post('/api/member/forget', {email});
};